/* Prendas Payas — animaciones con Motion (motion.dev, vendorizado en pp-motion-lib.js).
   Todo es mejora progresiva: si la lib no carga o el usuario pide reduced-motion, la web queda como estaba. */
(function () {
  if (!window.Motion) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var animate = Motion.animate;
  var inView = Motion.inView;
  var stagger = Motion.stagger;
  var suave = { duration: 0.65, ease: [0.22, 1, 0.36, 1] };
  var muelle = { type: 'spring', stiffness: 130, damping: 17 };

  function q(sel, ctx) { return (ctx || document).querySelectorAll(sel); }

  /* ---------- Página de producto ---------- */
  if (document.body.classList.contains('pp-tpl-product')) {
    var barra = document.querySelector('.pp-prod-barra');
    if (barra) animate(barra, { opacity: [0, 1], y: [-16, 0] }, suave);

    var fotos = q('.product-information__media .product-media-container');
    if (fotos.length) {
      animate(fotos, { opacity: [0, 1], y: [30, 0], scale: [0.965, 1] },
        Object.assign({ delay: stagger(0.09, { startDelay: 0.12 }) }, muelle));
    }

    var detalles = q('.product-details > *');
    if (detalles.length) {
      animate(detalles, { opacity: [0, 1], y: [18, 0] },
        Object.assign({ delay: stagger(0.07, { startDelay: 0.25 }) }, suave));
    }

    /* recomendaciones: se sirven al llegar con scroll */
    var recos = document.querySelector('product-recommendations');
    if (recos) {
      inView(recos, function (el) {
        var cards = q('.product-grid > *, .resource-list > *', el);
        if (cards.length) {
          animate(cards, { opacity: [0, 1], y: [26, 0] },
            Object.assign({ delay: stagger(0.08) }, suave));
        }
        return function () {};
      }, { amount: 0.15 });
    }

    /* añadir a la cesta: golpe de sello + pulso en el contador */
    document.addEventListener('click', function (e) {
      var boton = e.target.closest('add-to-cart-component .button, .product-form-buttons .button');
      if (!boton) return;
      animate(boton, { scale: [1, 0.94, 1.03, 1], rotate: [0, -1.2, 0.6, 0] }, { duration: 0.45 });
      var cesta = document.querySelector('.pp-prod-barra__cesta');
      if (cesta) animate(cesta, { scale: [1, 1.35, 1], color: ['#7a5c1e', '#2e2618', '#7a5c1e'] },
        Object.assign({ delay: 0.3 }, muelle));
    });

    /* tallas: micro-rebote al elegir */
    document.addEventListener('change', function (e) {
      var pill = e.target.closest('.variant-option') &&
        e.target.closest('.variant-option').querySelector('input:checked + label, label:has(input:checked)');
      if (pill) animate(pill, { scale: [1, 1.08, 1] }, { duration: 0.3 });
    });
  }

  /* ---------- Home: escena cafetería ---------- */
  var cafe = document.querySelector('.pp-cafe');
  if (cafe) {
    /* la pizarra invita: balanceo sutil cada pocos segundos hasta que entran */
    var pizarra = document.querySelector('.pp-pizarra');
    var invitar = pizarra && setInterval(function () {
      if (document.documentElement.classList.contains('pp-dentro')) { clearInterval(invitar); return; }
      animate(pizarra, { rotate: [0, -1.4, 1.1, -0.5, 0] }, { duration: 1.1, ease: 'easeInOut' });
    }, 6000);

    /* placas colgadas: vaivén perpetuo de taberna */
    q('.pp-placa').forEach(function (placa, i) {
      placa.style.transformOrigin = '50% -8px';
      animate(placa, { rotate: [-1.2, 1.2] },
        { duration: 3.2 + i * 0.5, repeat: Infinity, repeatType: 'reverse', ease: 'easeInOut' });
    });
  }

  /* ---------- Contacto: la nota se desliza sobre la barra ---------- */
  if (document.body.classList.contains('pp-tpl-page-contact')) {
    var campos = q('.contact-form form > *, form.contact-form > *');
    if (campos.length) {
      animate(campos, { opacity: [0, 1], y: [16, 0] },
        Object.assign({ delay: stagger(0.08, { startDelay: 0.15 }) }, suave));
    }
  }

  /* ---------- Global: enlaces y botones con presión física ---------- */
  document.addEventListener('pointerdown', function (e) {
    var el = e.target.closest('.pp-stamp, .pp-mesa__volver, .pp-prod-barra__volver');
    if (el) animate(el, { scale: 0.93 }, { duration: 0.12 });
  }, { passive: true });
  document.addEventListener('pointerup', function (e) {
    var el = e.target.closest('.pp-stamp, .pp-mesa__volver, .pp-prod-barra__volver');
    if (el) animate(el, { scale: 1 }, muelle);
  }, { passive: true });
})();
